import { randBetween } from "./math";

export const shuffle = <T extends Array<any>>(arr: T) =>
  arr.slice().sort(() => 0.5 - Math.random()) as T;

export const randEl = <T extends Array<any>>(arr: T) =>
  arr[randBetween(0, arr.length - 1)];
